import React from 'react'
import { LoaderFunctionArgs, ShouldRevalidateFunction } from 'react-router-dom'

import { QuoteRoutes } from './constants'
import { lazyLoadComponent, shouldRevalidateOnQueryChange } from './util'

const getOptionsBundle = () => import(/* webpackChunkName: "options" */ './modules/options')
const OptionsRoute = lazyLoadComponent({
  chunkName: 'options',
  load: getOptionsBundle,
})
const getRevenueBundle = () => import(/* webpackChunkName: "revenue" */ './modules/revenue')
const RevenueRoute = lazyLoadComponent({
  chunkName: 'revenue',
  load: getRevenueBundle,
})
const getDividendsBundle = () => import(/* webpackChunkName: "dividends" */ './modules/dividends')
const DividendsRoute = lazyLoadComponent({
  chunkName: 'dividends',
  load: getDividendsBundle,
})
const getEarningsBundle = () => import(/* webpackChunkName: "earnings" */ './modules/earnings')
const EarningsRoute = lazyLoadComponent({
  chunkName: 'earnings',
  load: getEarningsBundle,
})

export function getQuoteRouteLoader(args: LoaderFunctionArgs<any>) {
  const params = new URLSearchParams(args.request.url)
  const route = params.get('ty') as QuoteRoutes

  switch (route) {
    case QuoteRoutes.OptionsChain:
      return getOptionsBundle().then((value) => value.loader(args))
    case QuoteRoutes.Revenue:
      return getRevenueBundle().then((value) => value.loader())
    case QuoteRoutes.Dividends:
      return getDividendsBundle().then((value) => value.loader())
    case QuoteRoutes.Earnings:
      return getEarningsBundle().then((value) => value.loader())

    default:
      return () => {}
  }
}

export function getShouldRevalidateQuoteRoute(): ShouldRevalidateFunction {
  return (args) => {
    const route = args.currentUrl.searchParams.get('ty') as QuoteRoutes

    switch (route) {
      case QuoteRoutes.OptionsChain:
        return shouldRevalidateOnQueryChange(args, ['e', 's', 'ov'])

      default:
        return false
    }
  }
}

const quoteRouteSearchParams = new URLSearchParams(window.location.search)
const quoteRouteType = quoteRouteSearchParams.get('ty') as QuoteRoutes

export default function QuoteRoutesSwitch() {
  switch (quoteRouteType) {
    case QuoteRoutes.OptionsChain:
      return <OptionsRoute />
    case QuoteRoutes.Revenue:
      return <RevenueRoute />
    case QuoteRoutes.Dividends:
      return <DividendsRoute />
    case QuoteRoutes.Earnings:
      return <EarningsRoute />

    default:
      return null
  }
}
